import * as React from 'react';
import {withI18n, WithI18nProps} from '@shopify/react-i18n';
import {Icon, Stack, Caption, TextStyle} from '@shopify/polaris';
import {StarFilledMinor, FlagMajorMonotone} from '@shopify/polaris-icons';
import {formatCurrency, withPrecision} from 'utilities/numbers';
import {Money} from 'sections/types';

import * as styles from './ServiceMetrics.scss';

import withI18nArgs from './locales';

interface OwnProps {
  price?: Money;
  jobsCompleted?: number;
  overallRating?: number | null;
  totalReviews?: number;
  variation: 'ServiceListingCard' | 'ExpertCard' | 'ServiceDetails';
}

type CombinedMetricsProps = OwnProps & WithI18nProps;

function ServiceMetrics({
  price,
  jobsCompleted,
  overallRating,
  totalReviews,
  variation,
  i18n,
}: CombinedMetricsProps) {
  return (
    <div className={styles[variation]}>
      <div className={styles.Item} role="group">
        <h3 className={styles.Heading}>
          {i18n.translate('ServiceMetrics.priceHeading')}
        </h3>
        <div className={styles.Metric}>
          {price && Number(price.amount)
            ? formatCurrency(price.amount, 0, price.currencyCode)
            : i18n.translate('ServiceMetrics.noPrice')}
        </div>
      </div>
      <div className={styles.Item} role="group">
        <h3 className={styles.Heading}>
          {i18n.translate('ServiceMetrics.jobsCompletedHeading')}
        </h3>
        <div className={styles.Metric}>
          <Stack alignment="center" spacing="tight">
            <Icon color="inkLightest" source={FlagMajorMonotone} />
            <Stack.Item>{jobsCompleted ? jobsCompleted : '0'}</Stack.Item>
          </Stack>
        </div>
      </div>
      <div className={styles.Item} role="group">
        <h3 className={styles.Heading}>
          {i18n.translate('ServiceMetrics.overallRatingHeading')}
        </h3>
        <div className={styles.Metric}>
          {overallRating ? (
            <Stack alignment="center" spacing="extraTight">
              <Icon color="yellow" source={StarFilledMinor} />
              <Stack.Item>
                <Stack alignment="center" spacing="extraTight">
                  <Stack.Item>{withPrecision(overallRating, 1)}</Stack.Item>
                  <Caption>
                    <TextStyle variation="subdued">({totalReviews})</TextStyle>
                  </Caption>
                </Stack>
              </Stack.Item>
            </Stack>
          ) : (
            <Stack alignment="center" spacing="extraTight">
              <Icon color="skyDark" source={StarFilledMinor} />
              <Stack.Item>
                {i18n.translate('ServiceMetrics.noReviews')}
              </Stack.Item>
            </Stack>
          )}
        </div>
      </div>
    </div>
  );
}

export default withI18n(withI18nArgs)(ServiceMetrics);
